import React, { useState, useEffect, useRef } from 'react'
import { Link, useLocation } from 'react-router-dom'
import styled from 'styled-components'
import { timeUtils } from '../../../../common/utils/timeUtil'
import { StringUtil } from '../../../../common/utils/stringUtil'
import useModalStore from '../../../../hooks/useModalStore'
import useUsersStore from '../../../../hooks/useUsersStore'
import clsx from 'clsx'
// import BannerGA from '../../../../components/banner/BannerGA';

const CommunityPhotoList = ({ items = [] }) => {
  const modalStore = useModalStore()
  const userStore = useUsersStore()
  const isAdmin = userStore.data.is_admin
  const location = useLocation()
  const query = new URLSearchParams(location.search)
  const page = parseInt(query.get('page')) || 1
  const category = location.pathname.replace('/community/', '')

  const [list, setList] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (items.length > 0) {
      setList(items)
      setIsLoading(false)
    } else {
      setIsLoading(true)
    }
  }, [items])

  return (
    <div className='list_area'>
      {!isLoading &&
        list.map((item, i) => {
          console.log('=== COMMUNITY PHOTO LIST RENDERING ===', item.wr_subject)
          const { wr_id, thumbnailCategoryPhoto, wr_subject, wr_name, time, wr_hit, wr_datetime, wr_good } = item
          const isBlind = (parseInt(item.report_count) || 0) >= 10
          const isWarning = (parseInt(item.report_count) || 0) >= 5 && (parseInt(item.report_count) || 0) < 10

          return (
            <>
              <div className='article' key={wr_id}>
                <Link
                  className='item'
                  to={`/community/${category}?page=${page}&id=${wr_id}&type=photo`}
                  onClick={(event) => {
                    window.reflowOnFocus()
                    if (!isAdmin && isBlind) {
                      event.preventDefault()
                      modalStore.openAlertModal({
                        message: '블라인드 처리된 게시물은 열람하실 수 없습니다.',
                      })
                    }
                  }}
                >
                  <div className='thumb'>
                    <div className='inner'>
                      {isBlind ? (
                        <img className='icon' src='/images/ic-blind.svg' />
                      ) : (
                        (() => {
                          const content = item.wr_content || item.content || ''
                          const isVideo =
                            content &&
                            (content.includes('<video') ||
                              content.includes('.mp4') ||
                              content.includes('.webm') ||
                              content.includes('.mov'))

                          // Check for iframe content (embedded videos)
                          const isIframe = content && content.includes('<iframe')

                          // Check for image content
                          const isImage = content && content.includes('<img')

                          const title = item.wr_subject || item.subject || ''
                          const isVideoByTitle =
                            title.toLowerCase().includes('video') ||
                            title.toLowerCase().includes('vid') ||
                            title.toLowerCase().includes('mp4')

                          let videoUrl = null
                          if ((isVideo || isVideoByTitle) && content) {
                            const videoTagMatch = content.match(/<video[^>]*src=["\']([^"\']+)["\'][^>]*>/i)
                            if (videoTagMatch) {
                              videoUrl = videoTagMatch[1]
                            } else {
                              const urlMatch = content.match(/(https?:\/\/[^\s<>"\']+\.(mp4|webm|mov|ogg))/i)
                              if (urlMatch) {
                                videoUrl = urlMatch[1]
                              }
                            }
                          }

                          const shouldShowVideo = (isVideo || isVideoByTitle) && (videoUrl || isVideoByTitle)
                          const shouldShowIframe = isIframe && !isImage && !shouldShowVideo
                          const hasNoMedia = !isImage && !isVideo && !isIframe

                          return shouldShowVideo ? (
                            <>
                              <video
                                src={
                                  videoUrl ||
                                  'data:video/mp4;base64,AAAAIGZ0eXBpc29tAAACAGlzb21pc28yYXZjMW1wNDEAAAAIZnJlZQAAAt1tZGF0AQAAAG1hdGE='
                                }
                                preload='metadata'
                                playsInline
                                webkit-playsinline='true'
                                muted
                                className={clsx('ct_m', 'fade', 'loaded', 'change', isWarning && 'warning')}
                                style={{
                                  width: '100%',
                                  height: '100%',
                                  objectFit: 'cover',
                                  backgroundColor: 'rgb(150 150 150)',
                                }}
                                onClick={(e) => {
                                  e.preventDefault()
                                  return false
                                }}
                                onError={(e) => {
                                  console.log('Video load error:', e)
                                }}
                                onLoadedMetadata={(e) => {
                                  // Force iOS to load first frame by seeking
                                  const video = e.target
                                  if (video.paused && video.currentTime === 0) {
                                    video.currentTime = 0.001
                                  }
                                }}
                                onCanPlay={(e) => {
                                  // Additional iOS Safari fix: ensure first frame is rendered
                                  const video = e.target
                                  if (video.paused && video.currentTime === 0) {
                                    // Briefly play and pause to force frame render on iOS
                                    video
                                      .play()
                                      .then(() => {
                                        video.pause()
                                        video.currentTime = 0.001
                                      })
                                      .catch(() => {
                                        // If autoplay is blocked, just seek to show first frame
                                        video.currentTime = 0.001
                                      })
                                  }
                                }}
                                onLoadedData={(e) => {
                                  console.log('Video loaded successfully:', e)
                                }}
                              />
                              <div
                                style={{
                                  position: 'absolute',
                                  top: 0,
                                  left: 0,
                                  right: 0,
                                  bottom: 0,
                                  background: 'rgba(0, 0, 0, 0.3)',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  zIndex: 5,
                                  pointerEvents: 'none',
                                }}
                              >
                                <div
                                  style={{
                                    width: '40px',
                                    height: '40px',
                                    background: 'rgba(0, 0, 0, 0.7)',
                                    borderRadius: '50%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: 'white',
                                    fontSize: '16px',
                                    fontWeight: 'bold',
                                  }}
                                >
                                  <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 256 256'>
                                    <path
                                      fill='#ffffff'
                                      d='m164.44 105.34l-48-32A8 8 0 0 0 104 80v64a8 8 0 0 0 12.44 6.66l48-32a8 8 0 0 0 0-13.32ZM120 129.05V95l25.58 17ZM216 40H40a16 16 0 0 0-16 16v112a16 16 0 0 0 16 16h176a16 16 0 0 0 16-16V56a16 16 0 0 0-16-16Zm0 128H40V56h176v112Zm16 40a8 8 0 0 1-8 8H32a8 8 0 0 1 0-16h192a8 8 0 0 1 8 8Z'
                                    />
                                  </svg>
                                </div>
                              </div>
                            </>
                          ) : shouldShowIframe ? (
                            <>
                              <div
                                style={{
                                  position: 'absolute',
                                  top: 0,
                                  left: 0,
                                  right: 0,
                                  bottom: 0,
                                  backgroundColor: 'rgb(150 150 150)',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  borderRadius: '6px',
                                }}
                              >
                                <div
                                  style={{
                                    width: '40px',
                                    height: '40px',
                                    background: 'rgba(0, 0, 0, 0.7)',
                                    borderRadius: '50%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: 'white',
                                    fontSize: '16px',
                                    fontWeight: 'bold',
                                  }}
                                >
                                  <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 256 256'>
                                    <path
                                      fill='#ffffff'
                                      d='m164.44 105.34l-48-32A8 8 0 0 0 104 80v64a8 8 0 0 0 12.44 6.66l48-32a8 8 0 0 0 0-13.32ZM120 129.05V95l25.58 17ZM216 40H40a16 16 0 0 0-16 16v112a16 16 0 0 0 16 16h176a16 16 0 0 0 16-16V56a16 16 0 0 0-16-16Zm0 128H40V56h176v112Zm16 40a8 8 0 0 1-8 8H32a8 8 0 0 1 0-16h192a8 8 0 0 1 8 8Z'
                                    />
                                  </svg>
                                </div>
                              </div>
                            </>
                          ) : hasNoMedia ? (
                            <div
                              style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                backgroundColor: 'rgb(150 150 150)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '6px',
                              }}
                            />
                          ) : (
                            <img
                              width='100%'
                              className={clsx('ct_m', 'fade', 'loaded', 'change', isWarning && 'warning')}
                              src={thumbnailCategoryPhoto}
                              style={{
                                objectFit: 'cover',
                                backgroundColor: 'rgb(150 150 150)',
                              }}
                            />
                          )
                        })()
                      )}
                      {isWarning && <img className='icon warning' src='/images/ic-warning.svg' />}
                    </div>
                  </div>
                  <p className={clsx('subject', isBlind && 'blinded')}>
                    {isBlind ? '*블라인드 처리된 게시물*' : wr_subject}
                  </p>
                  <Info>
                    <em>{item.member_info.nick != '' ? item.member_info.nick : wr_name}</em>
                    <div>
                      <span>
                        {timeUtils.getDifferenceDay(wr_datetime.split(' ')[0]) === 0
                          ? time
                          : StringUtil.replace('-', '.', wr_datetime.split(' ')[0])}
                      </span>
                      <span className={'like'}>{wr_good}</span>
                      <span className={'hit'}>{new Intl.NumberFormat('ko-KR').format(wr_hit)}</span>
                    </div>
                  </Info>
                </Link>
              </div>

              {/* NEW ADS #4 */}
              {/* {i === 3 && (
                <div key={i}>
                  <BannerGA
                    containerStyle={{
                      display: 'block',
                      width: 450,
                      height: 50,
                      marginTop: 16,
                    }}
                    gaSlot={'1817385919'}
                    width={450}
                    height={50}
                  />
              </div>
              )} */}
            </>
          )
        })}
    </div>
  )
}

const Info = styled.div`
  display: flex;
  flex-direction: column;
  em {
    font-size: 12px;
    color: #222;
  }
  > div {
    display: flex;
  }
  span {
    font-size: 12px;
    color: #999;
    margin-right: 8px;
    display: flex;
    align-items: center;
    &.like {
      :before {
        content: '';
        width: 9px;
        height: 9px;
        display: inline-block;
        background: url('/images/ic-like.svg') no-repeat center center;
        background-size: 9px;
        margin-right: 5px;
      }
    }
    &.hit {
      :before {
        content: '';
        width: 14px;
        height: 14px;
        display: inline-block;
        background: url('/images/ic-hit.svg') no-repeat center center;
        background-size: 14px;
        margin-right: 5px;
      }
    }
  }
`

export { CommunityPhotoList }
